import { render, staticRenderFns } from "./cardgrid_3.vue?vue&type=template&id=ff2f4302&scoped=true"
import script from "./cardgrid_3.vue?vue&type=script&lang=js"
export * from "./cardgrid_3.vue?vue&type=script&lang=js"
import style0 from "./cardgrid_3.vue?vue&type=style&index=0&id=ff2f4302&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff2f4302",
  null
  
)

export default component.exports